const getRequestSlice = (state) => state.request

export const getIsRequestPending = (state) => getRequestSlice(state).requestPending
